import React from 'react';

export default function StringLimit({ text = '', limit = 300}) {
    if (!text) return null;
    const limitedText = text.length > limit ? text.slice(0, limit) + '...' : text;
    return <span>{limitedText}</span>;
}